



























































import UserUtils, { User } from '@/utils/UserUtils';
import EnumerationUtils, { Enumeration } from '@/utils/EnumerationUtils';
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => Partial<User>,
    },
    mode: {
      type: String as () => 'create' | 'edit',
      required: true,
    },
    'error-messages': {
      type: Object as () => { [key: string]: string[] },
      default: () => ({}),
    },
  },

  computed: {
    internal: {
      get(): Partial<User> {
        return this.value || UserUtils.generateDefault();
      },
      set(val: Partial<User>) {
        this.$emit('input', val);
      },
    },
  },

  data(): {
    privileges?: Enumeration[];
  } {
    return {
      privileges: undefined,
    };
  },

  async mounted() {
    this.privileges = await EnumerationUtils.api.list({
      family_key: 'user_privilege',
    });
  },
});
